import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import * as moment from 'moment';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';

const KEY = '_ZfRoYdr';

@Injectable()
export class TokenStorageService {
  private _token: string = null;

  constructor(
    private cookieService: CookieService,
    private runtimeEnvironmentService: RuntimeEnvironmentService
  ) {
    this._token = this.readToken();
  }

  public getToken(): string {
    return this._token;
  }

  public setToken(token?: string) {
    // Don't save null token when current token is also null, avoiding unneeded
    // set-cookie which breaks response caching with nginx.
    if (this._token || token) {
      this._token = token;
      this.saveToken(token);
    }
  }

  private readToken(): string {
    return this.cookieService.get(KEY);
  }

  private saveToken(token: string) {
    if (token) {
      this.cookieService.put(KEY, token, {
        expires: moment().add(6, 'months').toDate(),
        domain: this.runtimeEnvironmentService.domain,
      });
    } else {
      this.cookieService.remove(KEY, {
        domain: this.runtimeEnvironmentService.domain
      });
    }
  }

  private saveForumData(key, data) {
    if (data) {
      this.cookieService.put(key, data, {
        expires: moment().add(6, 'months').toDate(),
        domain: this.runtimeEnvironmentService.domain
      });
    } else {
      this.cookieService.remove(key, {
        domain: this.runtimeEnvironmentService.domain
      });
    }
  }

  saveForumUsername(username: string) {
    this.saveForumData('site_username', username);
  }

  saveForumToken(token: string) {
    this.saveForumData('site_uid', token);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/token-storage.service.ts